import { render, staticRenderFns } from "./AuditItemIssueStatistics.vue?vue&type=template&id=2d6fa9f8"
import script from "./AuditItemIssueStatistics.vue?vue&type=script&lang=js"
export * from "./AuditItemIssueStatistics.vue?vue&type=script&lang=js"
import style0 from "./AuditItemIssueStatistics.vue?vue&type=style&index=0&id=2d6fa9f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports